import { h } from "preact";
import { useContext, } from "preact/hooks";
import { Button, Grid, Paper, Tooltip, Typography } from "@mui/material";

import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import palette from "../../theme/palette";
import { AppContext } from "../../AppContext";

export default function DealStatusCardP({ state, uid, mode }) {
    const app = useContext(AppContext);

    return (<Paper style="padding: 5px;">
        <Grid container spacing={1}>
            <Grid item xs={4}>
                <Typography variant="body1">Offre contre-signée</Typography>
            </Grid>

            <Grid item xs={4}>
                {state.actualDeal && state.actualDeal.ssb ? (

                    <CheckCircleIcon
                        style={{
                            color: palette.success.main,
                        }}
                    />

                ) : (
                    <Tooltip title="En attente de signature des vendeurs">
                        <ErrorIcon style={{
                            color: palette.warning.main,
                        }} />
                    </Tooltip>
                )}
            </Grid>
            <Grid item xs={4}>

            </Grid>

            <Grid item xs={4}>
                <Typography variant="body1">Offre</Typography>
            </Grid>

            <Grid item xs={4}>
                {state.actualDeal && state.actualDeal.osb ? (

                    <CheckCircleIcon
                        style={{
                            color: palette.success.main,
                        }}
                    />

                ) : (
                    <Tooltip title="En attente de signature des acquéreurs">
                        <ErrorIcon style={{
                            color: palette.warning.main,
                        }} />
                    </Tooltip>
                )}
            </Grid>

            <Grid item xs={4}>

            </Grid>

        </Grid>
        <Grid container spacing={1} style="margin-top: 10px">
            <Grid item xs={4}>
                <Typography variant="body1">{state.actualDeal && state.actualDeal.pub ? "En vente" : "Publiable"}</Typography>
            </Grid>
            <Grid item xs={4}>
                {state.actualDeal && state.actualDeal.pub ? (

                    <CheckCircleIcon
                        style={{
                            color: palette.success.main,
                        }}
                    />

                ) : (
                    <Tooltip title="En attente de publication">
                        <ErrorIcon style={{
                            color: palette.warning.main,
                        }} />
                    </Tooltip>
                )}
            </Grid>
            <Grid item xs={4}>
                <Typography variant="h5">
                    {/* <a href={`/publicpage/${uid}`}>{state.actualDeal.pub ? "Voir en ligne" : "Prévisualiser"}</a> */}
                    <Button
                        style="width: 100%"
                        onClick={() => { window.location.href = `/publicpage/${uid}` }}
                    >
                        {state.actualDeal.pub ? "Voir en ligne" : "Prévisualiser"}
                    </Button>
                </Typography>
            </Grid>
        </Grid>

    </Paper >)

}